export const getApplyFormStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => (
  {
    '.recommendation-modal-overlay': {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundColor: 'rgba(51,51,51,0.3)',
      zIndex: '1061',
      '& .recommendation-modal': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        overflow: 'auto',
        outline: 'none',
        transform: 'translate(-50%,-50%)',
        marginRight: '-50%',
        padding: 24,
        border: '1px solid #d9d9d9',
        color: '#333',
        backgroundColor: palette.white,
        boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
        borderRadius: '2px',

        '& .recommendation-confirm-form': {
          width: 402,

          '& .close.close-image': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 12,
            lineHeight: '12px',
          },

          '& .recommendation-confirm-title': {
            fontFamily: 'Segoe UI',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: 20,
            lineHeight: '27px',
            marginBottom: 26,
            marginTop: 0,
          },

          '& .recommendation-confirm-content': {
            fontFamily: 'Segoe UI',
            fontSize: 14,
            lineHeight: '20px',
            marginBottom: 19,
          },

          '& .btn-confirm': {
            backgroundColor: palette.themePrimary,
            fontSize: 14,
            fontWeight: 600,
            marginRight: 8,
            lineHeight: '19px',
            color: palette.white,
          },

          '& .btn-cancel': {
            backgroundColor: palette.white,
            border: '1px solid #8A8886',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '19px',
          },
        },
        '& .recommendation-async-bulk-aar-confirm-form': {
          width: 402,

          '& .close.close-image': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 12,
            lineHeight: '12px',
          },

          '& .recommendation-aysnc-confirm-title': {
            fontFamily: 'Segoe UI',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: 20,
            lineHeight: '27px',
            marginBottom: 26,
            marginTop: 0,
          },

          '& .recommendation-async-confirm-content': {
            fontFamily: 'Segoe UI',
            fontSize: 14,
            lineHeight: '20px',
            marginBottom: 19,
            '& .blocker': {
              display: 'inline-block',

              '& .blocker-indicator': {
                position: 'relative',
                padding: 0,
                top: 2,
                left: 0,

                '& .blocker-image': {
                  height: 24,
                  width: 24,
                },
              },
            },
          },

          '& .btn-confirm': {
            backgroundColor: palette.themePrimary,
            fontSize: 14,
            fontWeight: 600,
            marginRight: 8,
            lineHeight: '19px',
            color: palette.white,
          },

          '& .btn-cancel': {
            backgroundColor: palette.white,
            border: '1px solid #8A8886',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '19px',
          },
        },
        '& .recommendation-async-apply-form': {
          width: 482,

          '& .closeimage': {
            fontSize: 16,
            position: 'relative',
            top: '-8px',
            right: '-8px',
            fontFamily: iconFontFamily,
          },

          '& .closeimage:before': {
            content: '"\\E711"',
          },

          '& .recommendation-async-apply-title': {
            fontFamily: 'Segoe UI',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '19px',
            color: palette.black,
            marginBottom: 12,
            marginTop: 0,

            '& .blocker': {
              display: 'inline-block',

              '& .blocker-indicator': {
                position: 'relative',
                padding: 0,
                top: 2,
                left: 0,

                '& .blocker-image': {
                  marginRight: 9,
                  height: 14,
                  width: 14,
                },
              },
            },
          },

          '& .recommendation-async-apply-actions': {
            fontFamily: 'Segoe UI',
            fontSize: 12,
            lineHeight: '16px',
            color: palette.black,
            marginBottom: 8,
          },

          '& .recommendation-apply-history': {
            fontFamily: 'Segoe UI',
            fontSize: 12,
            lineHeight: '16px',
            border: 'unset',
            padding: 'unset',
            color: '#337ABC',
          },
        },
      },
    },
  });
